type Props = { e2e?: string }
const injectE2E = (props: Props) => (props.e2e ? { 'data-e2e': props.e2e } : null)

export default injectE2E
